import type {RouteLocationNormalizedLoaded} from 'vue-router'

export async function useSimpleTourRuntimeData(route: RouteLocationNormalizedLoaded) {
    const searchRequest = simpleTourRuntimeStore.searchRequestFromQuery(route.query)
    if (simpleTourRuntimeStore.city.id !== searchRequest.cityId)
        await simpleTourRuntimeStore.loadCity(searchRequest.cityId)
}
